export default __webpack_public_path__ + "static/media/Predators.daaf446b.png";